import { useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";

import { fetchCurrentUser } from "@/api/endpoints/auth";
import { useAuthStore } from "@/store/authStore";

/** On a hard reload the access token only lives in memory (never
 * localStorage, to keep it out of reach of XSS) — so this attempts one
 * silent refresh via the httpOnly cookie before deciding auth state. */
export function RequireAuth() {
  const status = useAuthStore((s) => s.status);
  const accessToken = useAuthStore((s) => s.accessToken);
  const setSession = useAuthStore((s) => s.setSession);
  const clearSession = useAuthStore((s) => s.clearSession);

  useEffect(() => {
    if (status !== "unknown") return;
    fetchCurrentUser()
      .then((user) => setSession(useAuthStore.getState().accessToken ?? "", user))
      .catch(() => clearSession());
  }, [status, setSession, clearSession]);

  if (status === "unknown") {
    return <div className="flex h-screen items-center justify-center text-text-muted">Loading…</div>;
  }
  if (status === "unauthenticated" || !accessToken) {
    return <Navigate to="/login" replace />;
  }
  return <Outlet />;
}
